<template>
  <div>
    <div v-if="step == 1">
      <div class="row py-2" v-if="collection.length > 0">
        <div class="col-12">
          <button class="btn btn-primary" @click="stepImport(2)">Next Step</button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 grid-margin">
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            @change="getFiles"
            accept=".xls, .xlsx, .csv"
          ></b-form-file>
          <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div>
          <hr />
          <div class="form-group mt-2" v-if="collectionSheet.length > 1">
            <label>Select Sheet</label>
            <select class="d-block form-control" v-model="indexSheet" @change="previewFiles">
              <option
                v-for="(item, index) in collectionSheet"
                :key="index"
                v-bind:value="index"
              >{{ item }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row" v-if="collection.length > 0">
        <div class="col-12">
          <div>
            <b-table
              id="import-table"
              head-variant="dark"
              :responsive="true"
              :striped="true"
              :hover="true"
              :bordered="true"
              :items="collection"
              :per-page="perPage"
              :current-page="currentPage"
              caption-top
            >
              <template v-slot:table-caption>Data : {{ collection.length }}</template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="collection.length "
              :per-page="perPage"
              aria-controls="import-table"
              align="center"
              class="pagination pagination-rounded justify-content-center mt-4"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step == 2">
      <h5>Mapping</h5>
      <button type="button" @click="step = 1" class="btn btn-danger">Back</button>
      <form @submit.prevent="submitImport" ref="formImport">
        <table class="table table-hover table-bordered mb-0" id="table-leads">
          <thead>
            <tr>
              <th>File Columns Excel</th>
              <th>Fields</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item_label, index) in label" :key="index">
              <td>
                {{ item_label }}
                <input type="hidden" name="key" :value="item_label" />
              </td>
              <td>
                <div class="form-group">
                  <select class="select2 form-control" name="value">
                    <option value="none">None</option>
                    <option
                      v-for="(item, index) in fields"
                      :key="index"
                      :value="item[alias_table+'_f_name']"
                    >{{ item[alias_table+'_f_label'] }}</option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <button type="submit" class="btn btn-success">Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
import xlsx from "xlsx";

export default {
  props: {
    module: {
      type: String,
      required: true,
    },
    table_module: {
      type: String,
      required: true,
    },
    alias_table: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      collection: [],
      collectionSheet: [],
      dummyFiles: null,
      indexSheet: null,
      label: [],
      currentPage: 1,
      perPage: 5,
      step: 1,
      file: null,
      fields: {},
    };
  },
  methods: {
    getFiles(e) {
      var that = this;
      that.collection = [];
      var obj = {};
      var files = e.target.files,
        f = files[0];

      that.dummyFiles = e;
      that.collectionSheet = [];
      that.indexSheet = null;
      that.label = [];

      var reader = new FileReader();

      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = xlsx.read(data, { type: "array" });
        let dataSheet = workbook.SheetNames;
        /* DO SOMETHING WITH workbook HERE */

        if (dataSheet.length == 1) {
          that.indexSheet = 0;
          let sheetName = workbook.SheetNames[that.indexSheet];
          let worksheet = workbook.Sheets[sheetName];
          that.collection = xlsx.utils.sheet_to_json(worksheet);

          if (that.collection.length > 0) {
            obj = that.collection[0];
            for (const key in obj) {
              that.label.push(key);
            }
          }
        }

        that.collectionSheet = workbook.SheetNames;
      };
      if (f !== "undefined" && f !== undefined) {
        reader.readAsArrayBuffer(f);
      }
    },
    previewFiles: function () {
      var e = this.dummyFiles;
      var that = this;
      var obj = {};
      that.label = [];
      that.collection = [];
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();

      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = xlsx.read(data, { type: "array" });
        let sheetName = workbook.SheetNames[that.indexSheet];
        /* DO SOMETHING WITH workbook HERE */

        let worksheet = workbook.Sheets[sheetName];
        that.collection = xlsx.utils.sheet_to_json(worksheet);

        if (that.collection.length > 0) {
          obj = that.collection[0];
          for (const key in obj) {
            that.label.push(key);
          }
        }
      };
      if (f !== "undefined" && f !== undefined) {
        reader.readAsArrayBuffer(f);
      }
    },
    stepImport(arm = 1) {
      this.step = arm;
      var uri = this.table_module;
      if (this.table_module == "customers") {
        uri = "users";
      }

      this.axios.get("/" + uri + "/create").then((response) => {
        this.fields = response.data.data;

        if(this.table_module == 'services' || this.table_module == 'services_bulk'){
          let find = this.fields.findIndex(
            (r) => r[this.alias_table + "_f_name"] == 'crs_brand_id'
          );

          if (find >= -1) 
          {
            this.$delete(this.fields, find)
          }
        }
      });
    },
    submitImport(event) {
      var data = {
        key: [],
        value: [],
      };

      var formData = new FormData(event.target);

      // var serialize_data = $("#formImportData").serializeArray();
      for (var pair of formData.entries()) {
        if (pair[0] == "key") {
          data["key"].push(pair[1]);
        } else if (pair[0] == "value") {
          data["value"].push(pair[1]);
        }
      }

      var params = {
        data: data,
        collection: this.collection,
      };

      var uri = this.table_module;
      if (this.table_module == "customers") {
        uri = "users";
      }

      this.axios
        .post("/" + uri + "/import", params)
        .then((response) => {
          if (response.data.status == 200) {
            this.$toast("Import data berhasil");
            this.$router.push({ name: this.table_module });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              this.$toast.error("Gagal Import data");
            }
          }
        });
    },
  },
};
</script>